export interface StreamConfig {
    id: number;
    label: string;
    streamUserName: string;
    streamPwd: string;
    streamUrl: string;
    cameraIds: number[];
}

export const STREAM_CONFIG: StreamConfig[] = [
    {
        id: 15,
        label: 'Cabane Boé',
        streamUserName: 'client',
        streamPwd: 'Iphone47000',
        streamUrl: '150.228.18.8:25000',
        cameraIds: [1, 5, 2, 3, 6, 7],
    },
    {
        id: 11,
        label: 'Boutique Tourny',
        streamUserName: 'Mobile',
        streamPwd: 'Mobile33',
        streamUrl: '83.195.141.222:25000',
        cameraIds: [11, 10, 12, 14, 15, 16, 17, 18, 19],
    },
    {
        id: 3,
        label: 'Cabane Le Passage',
        streamUserName: 'prestataire',
        streamPwd: 'Mobile33',
        streamUrl: '80.15.211.88:25000',
        cameraIds: [6, 13, 7, 8, 10, 12, 4],
    },
    {
        id: 23,
        label: "Cabane St Jean D'illac",
        streamUserName: 'Mobile',
        streamPwd: 'Mobile33',
        streamUrl: '83.192.188.187:25000',
        cameraIds: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    },
    {
        id: 18,
        label: 'Cabane Pitoy',
        streamUserName: 'mobile',
        streamPwd: 'Mobile924139',
        streamUrl: '80.15.199.113:25000',
        cameraIds: [12, 13, 14, 15, 16, 17, 18, 21],
    },
    {
        id: 24,
        label: 'Cabane TAG',
        streamUserName: 'client',
        streamPwd: 'Iphone47000',
        streamUrl: '86.234.127.222:25000',
        cameraIds: [5, 2, 3, 4, 1, 6, 7, 8],
    },
    {
        id: 22,
        label: 'Boutique Wilson',
        streamUserName: 'Mobile',
        streamPwd: 'Mobile33',
        streamUrl: '83.192.215.135:25000',
        cameraIds: [7, 5, 4, 6, 8, 9, 10, 11],
    },
    {
        id: 30,
        label: 'Cabane St Charles',
        streamUserName: 'admin',
        streamPwd: 'Seek-One25!!',
        streamUrl: '90.92.139.117:25000',
        cameraIds: [10, 17, 16, 7, 11, 12, 8, 21, 18, 19, 20],
    },
    {
        id: 32,
        label: 'Boutique Poissonière',
        streamUserName: 'admin',
        streamPwd: 'Seek-One25!!',
        streamUrl: '90.127.176.96:25000',
        cameraIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    {
        id: 31,
        label: 'Boutique Freres Bonnies',
        streamUserName: 'Mobile',
        streamPwd: 'Mobile33',
        streamUrl: '83.195.247.193:25000',
        cameraIds: [4, 3, 2, 5, 6, 7, 8],
    },
    {
        id: 17,
        label: 'Boutique Montaury',
        streamUserName: 'mobile33!',
        streamPwd: 'mobile33!',
        streamUrl: '90.30.61.171:25000',
        cameraIds: [7, 5, 2, 3, 4, 6, 8, 9, 10],
    },
    {
        id: 40,
        label: 'Boutique Gaillac',
        streamUserName: 'client',
        streamPwd: 'Iphone81',
        streamUrl: '90.21.23.9:25000',
        cameraIds: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    },
    {
        id: 41,
        label: 'Boutique Merignac',
        streamUserName: 'Mobile',
        streamPwd: 'Mobile33',
        streamUrl: '86.213.57.115:25000',
        cameraIds: [1, 3, 4, 5, 6, 7, 8, 9, 10],
    },
    {
        id: 63,
        label: 'Boutique Verdun',
        streamUserName: 'client',
        streamPwd: 'Iphone81000',
        streamUrl: '86.249.237.219:25000',
        cameraIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    {
        id: 61,
        label: 'Boutique Caprais',
        streamUserName: 'client',
        streamPwd: 'Iphone31000',
        streamUrl: '92.135.117.163:25000',
        cameraIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    },
    {
        id: 39,
        label: 'Boutique Talence',
        streamUserName: 'Mobile',
        streamPwd: 'Mobile33',
        streamUrl: '90.47.2.149:25000',
        cameraIds: [6, 12, 3, 9, 7, 10, 11, 2, 4, 5, 1, 8],
    },
    {
        id: 62,
        label: 'Boutique Aucamville',
        streamUserName: 'client',
        streamPwd: 'Iphone31000',
        streamUrl: '109.220.193.229:25000',
        cameraIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    },
];

export interface PublicStreamConfig {
    id: number;
    label: string;
    cameraIds: number[];
}

export const PUBLIC_STREAM_CONFIG: PublicStreamConfig[] = STREAM_CONFIG.map((config) => ({
    id: config.id,
    label: config.label,
    cameraIds: config.cameraIds,
}));

export type StreamSize = 'preview' | 'full';
